import { useEffect, useState } from "react";
import getSubAdminData from "../api/services/Users/get_sub_admi_branch_data";

const useFilteredCollectionData = (collectionName, condition, value) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (value) {
      const unsubscribe = getSubAdminData(
        collectionName,
        value,
        (data) => {
          setData(data);
        }
      );

      return () => {
        unsubscribe();
      };
    }
  }, [collectionName, condition, value]);

  return { data };
};

export default useFilteredCollectionData;
